import { render } from "./Character_profile.vue?vue&type=template&id=284c83d6&scoped=true"
import script from "./Character_profile.vue?vue&type=script&lang=js"
export * from "./Character_profile.vue?vue&type=script&lang=js"

import "./Character_profile.vue?vue&type=style&index=0&id=284c83d6&scoped=true&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284c83d6"]])